import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

function Posts() {
  const [posts, setPosts] = useState([]);
  const [searchCategory, setSearchCategory] = useState("");

  // FETCH POSTS
  const fetchPosts = async () => {
    try {
      const res = await axios.get("http://localhost:5000/api/posts");
      setPosts(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchPosts();
  }, []);

  // DELETE POST
  const deletePost = async (id) => {
    const confirmDelete = window.confirm("Delete this post?");
    if (!confirmDelete) return;

    try {
      await axios.delete(`http://localhost:5000/api/posts/${id}`);
      fetchPosts();
    } catch (err) {
      console.log(err);
    }
  };

  // FILTER POSTS
  const filteredPosts =
    searchCategory === ""
      ? posts
      : posts.filter((post) => post.category === searchCategory);

  return (
    <section className="min-h-screen bg-[#F5F7FA] pt-32 px-4 md:px-14 pb-14">

      {/* HEADER */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 mb-10">

        <div>
          <p className="uppercase tracking-[5px] text-yellow-600 font-semibold text-sm mb-3">
            Admin Panel
          </p>

          <h1 className="text-3xl md:text-5xl font-bold text-[#0B1C39]">
            All Posts
          </h1>
        </div>

        {/* RIGHT SIDE CONTROLS */}
        <div className="flex flex-col sm:flex-row gap-3">

          {/* SEARCH BAR */}
          <select
            value={searchCategory}
            onChange={(e) => setSearchCategory(e.target.value)}
            className="border px-4 py-3 rounded-2xl w-full sm:w-auto"
          >
            <option value="">All Categories</option>
            <option value="Blog">Blog</option>
            <option value="Legal Guide">Legal Guide</option>
            <option value="Legal Update">Legal Update</option>
            <option value="FAQ">FAQ</option>
            <option value="Case Study">Case Study</option>
          </select>

          {/* DASHBOARD BUTTON */}
          <Link
            to="/admin/dashboard"
            className="bg-gray-700 text-white px-6 py-3 rounded-2xl font-semibold hover:bg-gray-800 text-center"
          >
            Dashboard
          </Link>

          {/* CREATE BUTTON */}
          <Link
            to="/admin/create-post"
            className="bg-[#0B3D91] text-white px-6 py-3 rounded-2xl font-semibold hover:bg-[#082b67] text-center"
          >
            Create Post
          </Link>

        </div>
      </div>

      {/* TABLE */}
      <div className="bg-white rounded-[32px] shadow-xl overflow-hidden border border-gray-100">

        <div className="overflow-x-auto">

          <table className="w-full">

            <thead className="bg-[#0B3D91] text-white">
              <tr>
                <th className="text-left px-6 py-5">Image</th>
                <th className="text-left px-6 py-5">Title</th>
                <th className="text-left px-6 py-5">Category</th>
                <th className="text-left px-6 py-5">Status</th>
                <th className="text-left px-6 py-5">Actions</th>
              </tr>
            </thead>

            <tbody>
              {filteredPosts.map((post) => (
                <tr
                  key={post.id}
                  className="border-b border-gray-100 hover:bg-gray-50 transition"
                >

                  <td className="px-6 py-5">
                    <img
                      src={`http://localhost:5000${post.featured_image}`}
                      alt={post.title}
                      className="w-20 h-20 object-cover rounded-xl"
                    />
                  </td>

                  <td className="px-6 py-5 font-semibold text-[#0B1C39]">
                    {post.title}
                  </td>

                  <td className="px-6 py-5 text-gray-600">
                    {post.category}
                  </td>

                  <td className="px-6 py-5">
                    <span className="bg-green-100 text-green-700 px-4 py-2 rounded-full text-sm font-semibold">
                      {post.status}
                    </span>
                  </td>

                  <td className="px-6 py-5 flex gap-3">
                    <Link
                      to={`/admin/edit-post/${post.id}`}
                      className="bg-yellow-500 text-white px-4 py-2 rounded-xl hover:bg-yellow-600 transition"
                    >
                      Edit
                    </Link>

                    <button
                      onClick={() => deletePost(post.id)}
                      className="bg-red-500 text-white px-4 py-2 rounded-xl hover:bg-red-600 transition"
                    >
                      Delete
                    </button>
                  </td>

                </tr>
              ))}
            </tbody>

          </table>
        </div>
      </div>
    </section>
  );
}

export default Posts;